import { createFileRoute, redirect } from '@tanstack/react-router'

// /demo is a vanity alias for the demo-booking page — it carries no content of
// its own and redirects straight to /contact. This handles client-side
// navigation within the SPA; the build also emits a static dist/demo/index.html
// meta-refresh stub (scripts/prerender.ts) so a direct hit or a crawler
// redirects without booting the SPA. Kept out of ROUTE_META so it stays out of
// the sitemap and isn't indexed as its own page.
export const Route = createFileRoute('/demo')({
  beforeLoad: () => {
    throw redirect({ to: '/contact/' })
  },
})
